export default __webpack_public_path__ + "static/media/PAFI Pemanggilan RUPS The Invitation of GMS 2026.af809f25.pdf";